module.exports = {
      id: "movie-icon-usage",
      viewBox: "0 0 16 19",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#movie-icon",
      toString: function () {
        return this.url;
      }
    }